import { render } from "./ContactView.vue?vue&type=template&id=7efe3f72&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=7efe3f72&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efe3f72"]])

export default __exports__